import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

interface BreadcrumbItem {
  label: string;
  path: string;
  active?: boolean;
}

export function useBreadcrumbs(): BreadcrumbItem[] {
  const location = useLocation();

  return useMemo(() => {
    const segments = location.pathname.split('/').filter(Boolean);

    if (segments.length === 0) {
      return [{ label: 'Home', path: '/', active: true }];
    }

    const items: BreadcrumbItem[] = [
      { label: 'Home', path: '/', active: false },
    ];

    let currentPath = '';
    for (const segment of segments) {
      currentPath += `/${segment}`;
      const label = segment
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      items.push({ label, path: currentPath, active: false });
    }

    if (items.length > 0) {
      items[items.length - 1].active = true;
    }

    return items;
  }, [location.pathname]);
}
